<template>
  <div>
    <transition v-if="!isFiltering && !isEmpty" name="fade" mode="out-in">
      <div class="media-library__items">
        <a
            class="media-library__item"
            v-for="download in activeDownloads"
            :href="download.url"
            :key="download.id"
        >
          <figure v-if="download.imgSrc" class="media-library__item-image">
            <img :src="download.imgSrc" alt />
          </figure>
          <figure v-else class="media-library__item-icon" v-html="iconType(download.mediaType)">
          </figure>

          <div class="media-library__item-content">
            <p class="small">
              {{ download.mediaType }} <span v-html="download.vendor"></span><br> {{ download.date }}
            </p>
            <h3 class="h6" v-html="download.title"></h3>
            <div class="media-library__item-lnk" v-if="download.ctaText">
              <span v-html="download.ctaText"></span>
              <span class="media-library__item-lnk-btn btn-primary">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                      d="M12 20L10.95 18.925L17.125 12.75H4V11.25H17.125L10.95 5.075L12 4L20 12L12 20Z"
                      fill="currentColor" />
                </svg>
              </span>
            </div>
          </div>
        </a>
      </div>
    </transition>
    <transition v-if="!isFiltering && isEmpty" name="fade" mode="out-in">
      <h3 class="no-results" v-html="settings.searchNoResults"></h3>
    </transition>
    <Loader v-if="isLazyLoading" />
  </div>
</template>
<script setup>
import { computed } from 'vue';
import Loader from '../Loader/Loader.vue';

const props = defineProps( {
  downloads: {
    type: Array,
    default: [],
    required: true
  },
  isEmpty: {
    type: Boolean,
    default: false
  },
  isLazyLoading: {
    type: Boolean,
    default: false
  },
  isFiltering: {
    type: Boolean,
    default: false
  },
  settings: {
    type: Object,
    required: true
  }
} );

const activeDownloads = computed( () => props.downloads.filter( download => download.isActive && ! download.isFilteredOut ) );

/**
 *
 * @param {string} type The type of icon to return.
 * @return {string}
 */
const iconType = ( type ) => {
  switch ( type ) {
    case 'Factsheet':
      return `
          <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 42C6.2 42 5.5 41.7 4.9 41.1C4.3 40.5 4 39.8 4 39V9C4 8.2 4.3 7.5 4.9 6.9C5.5 6.3 6.2 6 7 6H41.8C42.6 6 43.3 6.3 43.9 6.9C44.5 7.5 44.8 8.2 44.8 9V39C44.8 39.8 44.5 40.5 43.9 41.1C43.3 41.7 42.6 42 41.8 42H7ZM7 39H41.8V9H7V39ZM10.4 34H20.4V30H10.4V34ZM29.5 30L39.4 20.1L36.55 17.25L29.5 24.35L26.65 21.5L23.85 24.35L29.5 30ZM10.4 26H20.4V22H10.4V26ZM10.4 18H20.4V14H10.4V18ZM7 39V9V39Z" fill="currentColor"/>
          </svg>
        `;
    case 'Video':
      return `<svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M19.6 32.35L32.6 23.9L19.6 15.45V32.35ZM7 40C6.2 40 5.5 39.7 4.9 39.1C4.3 38.5 4 37.8 4 37V11C4 10.2 4.3 9.5 4.9 8.9C5.5 8.3 6.2 8 7 8H41C41.8 8 42.5 8.3 43.1 8.9C43.7 9.5 44 10.2 44 11V37C44 37.8 43.7 38.5 43.1 39.1C42.5 39.7 41.8 40 41 40H7ZM7 37H41V11H7V37ZM7 37V11V37Z" fill="currentColor"/>
            </svg>`;
    default:
      return `
          <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 42C8.2 42 7.5 41.7 6.9 41.1C6.3 40.5 6 39.8 6 39V9C6 8.2 6.3 7.5 6.9 6.9C7.5 6.3 8.2 6 9 6H32.1L42 15.9V39C42 39.8 41.7 40.5 41.1 41.1C40.5 41.7 39.8 42 39 42H9ZM9 39H39V17.55H30.45V9H9V39ZM13.95 33.45H34.05V30.45H13.95V33.45ZM13.95 17.55H24V14.55H13.95V17.55ZM13.95 25.5H34.05V22.5H13.95V25.5ZM9 9V17.55V9V39V9Z" fill="currentColor"/>
          </svg>
        `;
  }
};
</script>
